<template>
  <div v-if="isLoading" class="w-full pb-[100px] md:pb-[160px]">
    <TopNav
      ref="topNav"
      @onNav="onNav"
      @handelcd="handelcd"
      @onSearch="onSearch"
      :logo="data.new_url"
      :typeClass="data.video_type_name"
      :web_name="data.web_name"
      :isHome="true"
    ></TopNav>
    <NoticeBar :list="data.gundong_text[0] ? [data.gundong_text[0]] : []"></NoticeBar>
    <TopWz class="py-0" :list="data.homt_text"></TopWz>
    <NoticeBar :list="data.gundong_text[1] ? [data.gundong_text[1]] : []"></NoticeBar>
    <!-- <SwaperView class="pb-[0]" :list="data.banner"></SwaperView> -->
    <!-- <h3 class="text-center my-[10px] text-[#e53333] text-[18px]">回家地址:88me.me</h3> -->
    <!-- <div class="text-[18px] text-[#7FFF00] text-center">
      <b v-for="(item, index) in data.text_ad" :key="index" @click="handelUrl(item)">
        {{ item.content }}
      </b>
    </div> -->
    <!-- 横幅 -->
    <HfView class="mt-[0px]" :list="data.home_hengfu"></HfView>
    <NoticeBar :list="data.gundong_text[2] ? [data.gundong_text[2]] : []"></NoticeBar>
    <div class="md:flex md:items-start md:justify-center w-full md:gap-[20px] target">
      <!-- 内容 -->
      <div class="w-full min-h-[100vh] flex flex-col">
        <!-- 视频 -->
        <div class="w-full mt-[0px]">
          <div class="text-[#fff] text-[18px] py-[0px] pl-[20px] w-full box-border borb mt-[20px]">
            {{ data.ad_list.title }}
          </div>
          <div v-for="(item, index) in [data.ad_list?.list]" :key="index" class="w-full">
            <VideoList :loding="videoLoding" :lod_image="data.logo" :list="item"></VideoList>
          </div>
          <div
            class="text-[#fff] text-[18px] py-[0px] pl-[20px] w-full box-border borb"
            id="distance"
          >
            {{ videoTitle }}
          </div>
          <div v-for="(item, index) in videoList" :key="index" class="w-full">
            <VideoList :loding="videoLoding" :lod_image="data.logo" :list="item"></VideoList>
            <!-- 二维数组循环 -->
            <NoticeBar
              v-if="index == 0"
              :list="data.gundong_text[3] ? [data.gundong_text[3]] : []"
            ></NoticeBar>
            <GgView v-if="index == 0" :applist="data.home_app" :wzlist="data.homt_text"></GgView>
            <NoticeBar
              v-if="index == 0"
              :list="data.gundong_text[4] ? [data.gundong_text[4]] : []"
            ></NoticeBar>
          </div>
          <div v-for="(item, index) in videoList1" :key="index" class="w-full">
            <VideoList :loding="videoLoding" :lod_image="data.logo" :list="item"></VideoList>
            <GgView v-if="index == 0" :applist="data.home_app" :wzlist="data.homt_text"></GgView>
          </div>
          <!-- 分页 -->
          <div
            v-if="!isHome && videoLoding"
            class="flex items-center justify-center pb-[10px] gap-[10px] text-[12px] text-[#fff]"
          >
            <div
              class="cursor-pointer py-[5px] px-[15px] rounded-[5px] bg-[#FF3565] bobb"
              @click="handelPage(1)"
            >
              首页
            </div>
            <div
              class="cursor-pointer py-[5px] px-[15px] rounded-[5px] bg-[#FF3565] bobb"
              @click="handelPagetop"
            >
              上一页
            </div>
            <div
              class="cursor-pointer py-[5px] px-[15px] rounded-[5px] md:hidden bg-[#FF3565] bobb"
            >
              {{ page }}/{{ last_page }}
            </div>
            <div
              v-for="(item, index) in visiblePages"
              :key="index"
              class="cursor-pointer py-[5px] px-[15px] rounded-[5px] hidden md:block bg-[#FF3565] bobb"
              :class="{ active: page == item }"
              @click="goToPage(item)"
            >
              {{ item }}
            </div>

            <div
              class="cursor-pointer py-[5px] px-[15px] rounded-[5px] bg-[#FF3565] bobb"
              @click="handelPagebottom"
            >
              下一页
            </div>
            <div
              class="cursor-pointer py-[5px] px-[15px] rounded-[5px] bg-[#FF3565] bobb"
              @click="handelw"
            >
              尾页
            </div>
          </div>
        </div>
        <NoticeBar :list="data.gundong_text[5] ? [data.gundong_text[5]] : []"></NoticeBar>
        <BottomWz :list="data.homt_text"></BottomWz>
        <NoticeBar :list="data.gundong_text[6] ? [data.gundong_text[6]] : []"></NoticeBar>
        <div
          class="w-full mt-[20px] box-border p-[10px] rounded-[5px] flex flex-col items-center justify-center"
        >
          <!-- https://t.me/madoudou2024 -->
          <div class="text-[14px] font-600 text-[#ff0000]">
            <span>广告合作：</span
            ><span class="" @click="handeltelegram(data.telegram)">@{{ telegram }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-else class="h-[100vh] w-full bg-[#222222] flex items-center justify-center text-[#fff]">
    <van-loading vertical>
      <template #icon>
        <van-icon name="star-o" size="30" />
      </template>
      加载中...
    </van-loading>
  </div>
  <!-- 上下侧边 -->
  <TopBootm
    ref="topBootmRef"
    :clist="data.home_xuanfu"
    :xlist="data.home_bottom"
    :slist="data.home_top"
  ></TopBootm>
  <TcView v-if="data.da && data.da.length" :list="data.da" @close="close"></TcView>
  <GgTan v-if="data.xiao && data.xiao.length" ref="GgTanRef" :applist="data.xiao"></GgTan>
  <ZxTc
    ref="zxTxRef"
    :obj="{
      home_domain: data.home_domain,
      web_name: data.web_name
    }"
  ></ZxTc>

  <van-back-top style="background-color: #ff3565" class="custom"> </van-back-top>
</template>

<script setup>
import { ref, onMounted, nextTick, computed } from 'vue'
import { useRouter } from 'vue-router'
import { homeData, getVideo } from '@/api/api'
import TopNav from '@/components/common/TopNav.vue'
import TopWz from '@/components/common/TopWz.vue'
import BottomWz from '@/components/common/BottomWz.vue'
import NoticeBar from '@/components/common/NoticeBar.vue'
import HfView from '@/components/common/HfView.vue'
import TopBootm from '@/components/common/TopBootm.vue'
import GgView from '@/components/common/GgView.vue'
import GgTan from '@/components/common/GgTan.vue'
// import VideoGg from '@/components/common/VideoGg.vue'
import VideoList from '@/components/common/VideoList.vue'
import TcView from '@/components/common/TcView.vue'
// import ZxTc from '@/components/common/ZxTc.vue'
import SwaperView from '@/components/common/SwaperView.vue'
import { pcScrollX, xorDecrypt } from '@/utils/common'
import { transformConfig, transformVideoList } from '@/utils/transform'

const isLoading = ref(false)
const videoLoding = ref(false)
const GgTanRef = ref(null)
const zxTxRef = ref(null)
const handelcd = () => {
  zxTxRef.value.handelShow()
  // isMobile.value = !isMobile.value
}
const close = () => {
  // zxTxRef.value.handelShow()
  // nextTick(() => {
  //   if (GgTanRef.value) {
  //     GgTanRef.value.handelShow()
  //   }
  // })
}
const isHome = ref(true)
const go = ref('')
const ss = ref('')
onMounted(() => {
  // 滚动到顶部
  window.scrollTo(0, 0)
  go.value = sessionStorage.getItem('isIndex') || ''
  ss.value = sessionStorage.getItem('vod_name') || ''
  // console.log(ss.value, 'ss')

  getHomeData()
  // getMy()
})
const videoTitle = ref('')
const type_id = ref('')
const onNav = ({ item, num }) => {
  videoTitle.value = item.type_name
  type_id.value = item.type_id
  // localStorage.removeItem('page')
  page.value = 1
  videoList.value = []
  // getVideoList(`page=${page.value}`)
  if (!item.type_id) {
    getVideoList(``, 'search')
    isHome.value = true
  } else {
    page.value = num ? num : 1
    getVideoList(`page=${page.value}&type_id=${item.type_id}`, 'search')
    isHome.value = false
  }
}

function insertByNum(arr1, arr2) {
  const result = [...arr2] // 复制数组2，避免修改原数组
  arr1.forEach((item) => {
    if (item.num >= 0 && item.num <= result.length) {
      result.splice(item.num, 0, item) // 按 num 索引插入
    } else {
      result.push(item) // 超出范围，追加到最后
    }
  })
  return result
}

const page = ref(1)
const videoList = ref([])
const videoList1 = ref([])
const last_page = ref(0)
const getVideoList = async (param, type) => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  })
  videoLoding.value = false
  videoList.value = []
  videoList1.value = []
  const res = await getVideo(param)
  let decodedString = atob(res.key)
  // const data = JSON.parse(xorDecrypt(res.data, decodedString))
  const datas = JSON.parse(xorDecrypt(res.data, decodedString))
  // videoTitle.value = datas.title
  // console.log(datas, 'datas')
  if (datas.title) {
    const list = splitIntoTwo(datas.list)
    videoList.value = [list[0]]
    videoList1.value = [list[1]]
    // console.log(splitIntoTwo(datas.list), 'videoList.value')
    videoTitle.value = datas.title
    videoLoding.value = true
    return
  }
  last_page.value = datas.last_page
  if (type == 'search') {
    videoList.value = [datas.data]
  } else {
    videoList.value = [datas]
  }
  // videoLoding.value = true
  // videoList.value = [datas.list]
  videoLoding.value = true
  // console.log(videoList.value, 'videoList.value')
}
function splitIntoTwo(array) {
  const mid = Math.ceil(array.length / 2)
  return [array.slice(0, mid), array.slice(mid)]
}
// function splitIntoTwo(array) {
//   let mid = Math.ceil(array.length / 2) // 计算中间索引，向上取整
//   if (mid % 2 !== 0) mid += 1 // 如果 mid 是奇数，则 +1 变偶数
//   return [array.slice(0, mid), array.slice(mid)]
// }

const download = () => {
  if (!data.value.app_url) return
  window.open(data.value.app_url, '_blank')
}

const topBootmRef = ref(null)
const topNav = ref(null)
const data = ref({
  gundong_text: []
})
const telegram = ref('')
const getHomeData = async () => {
  // showLoadingToast({ duration: 0, loadingType: 'spinner' })
  try {
    const res = await homeData()
    // console.log(res)

    if (res == 304) {
      // console.log('1111')
      const bas = JSON.parse(localStorage.getItem('data'))
      let decodedString = atob(bas.key)
      // const data = JSON.parse(xorDecrypt(res.data, decodedString))
      const datas = JSON.parse(xorDecrypt(bas.data, decodedString))
      if (datas.video_type_name.length) {
        if (datas.video_type_name[0].type_name != '首页') {
          datas.video_type_name.unshift({ type_id: 0, type_name: '首页' })
        }
      }
      data.value = datas
      data.value.xiao = data.value.pop_up.filter((item) => item.type === 1)
      data.value.da = data.value.pop_up.filter((item) => item.type === 2)
    } else {
      // console.log('2222')
      localStorage.setItem('data', JSON.stringify(res))
      let decodedString = atob(res.key)
      // const data = JSON.parse(xorDecrypt(res.data, decodedString))
      const datas = JSON.parse(xorDecrypt(res.data, decodedString))
      // console.log(datas, 'datas')

      datas.video_type_name.unshift({ type_id: 0, type_name: '首页' })
      data.value = datas
      data.value.xiao = data.value.pop_up.filter((item) => item.type === 1)
      data.value.da = data.value.pop_up.filter((item) => item.type === 2)
      // console.log(data.value, 'datas1111')
    }

    // console.log(data.value, 'data')
    // data.value.pop_up = ''
    // console.log(data.value, 'data.value.pop_up111111')

    if (data.value.xiao && data.value.xiao.length) {
      nextTick(() => {
        if (GgTanRef.value) {
          GgTanRef.value.handelShow()
        }
      })
    }
    // if (!sessionStorage.getItem('wz')) {
    //   close()
    // }
    document.title = data.value.web_name
    // 使用正则表达式提取 `https://t.me/` 后面的部分
    if (data.value.telegram) {
      let match = data.value.telegram.match(/https:\/\/t\.me\/(.*)/)
      if (match) {
        telegram.value = match[1] // match[1] 是正则表达式中第一个捕获组的内容
      }
    }
    page.value = 1
    // console.log(res, '2222')
    videoTitle.value = data.value.video_type_name[0].type_name
    type_id.value = data.value.video_type_name[0].type_id
    // getVideoList(`page=${page.value}`, 'list')
    nextTick(() => {
      // console.log('nextTick')
      isLoading.value = true
      setTimeout(() => {
        topBootmRef.value.scroll()
        pcScrollX()
      }, 50)
    })
    if (ss.value) {
      // 这里是搜索
      onSearch(ss.value)
      sessionStorage.removeItem('vod_name')
      return
    }
    if (go.value) {
      nextTick(() => {
        setTimeout(() => {
          page.value = +localStorage.getItem('page') || 1
          topNav.value.homeClassNav(page.value)
        }, 200)
        // sessionStorage.removeItem('go')
      })
    } else {
      getVideoList(``, 'search')
    }
    // closeToast()
  } catch (error) {
    // 捕获异常
    localStorage.removeItem('data')
    localStorage.removeItem('lastModified')
    // 刷新页面
    // location.reload()
    // console.error('发生错误:', error.message)
  }
}

// 搜索
const onSearch = (name) => {
  page.value = 1
  getVideoList(`page=${page.value}&vod_name=${name}`, 'search')
}

// 返回首页第一页
const handelPage = () => {
  if (page.value == 1) return
  page.value = 1
  getVideoList(`page=${page.value}&type_id=${type_id.value}`, 'search')
}

const handelPagetop = () => {
  if (page.value > 1) {
    page.value--
    localStorage.setItem('page', page.value)
    getVideoList(`page=${page.value}&type_id=${type_id.value}`, 'search')
  }
}
const handelPagebottom = () => {
  if (page.value == last_page.value) return
  page.value++
  localStorage.setItem('page', page.value)
  getVideoList(`page=${page.value}&type_id=${type_id.value}`, 'search')
}

// 计算分页按钮
const visiblePages = computed(() => {
  const total = last_page.value
  const current = page.value
  const range = 5 // 最多显示 5 个分页按钮
  let start = Math.max(1, current - Math.floor(range / 2))
  let end = Math.min(total, start + range - 1)

  // 调整 start 以保持范围
  if (end - start + 1 < range) {
    start = Math.max(1, end - range + 1)
  }

  return Array.from({ length: end - start + 1 }, (_, i) => start + i)
})
// 点击页码
const goToPage = (num) => {
  if (num >= 1 && num <= last_page.value) {
    page.value = num
    localStorage.setItem('page', page.value)
    getVideoList(`page=${page.value}&type_id=${type_id.value}`, 'search')
  }
}
const handelw = () => {
  if (page.value == last_page.value) return
  // console.log(page.value, last_page.value)

  page.value = last_page.value
  localStorage.setItem('page', page.value)
  getVideoList(`page=${page.value}&type_id=${type_id.value}`, 'search')
}

const handeltelegram = (item) => {
  if (item) {
    window.open(item, '_blank')
  }
}
const handelUrl = (item) => {
  if (item.href) {
    window.open(item.href, '_blank')
  }
}
</script>

<style scoped>
.borb {
  border-bottom: 1px solid #ff3565;
}
.bobb {
  border: 1px solid #eee;
}
.sh {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}
.active {
  background-color: #ff6666;
  border: 1px solid #ff6666;
}
:deep(.van-back-top) {
  background-color: #ff3565 !important;
}
.custom {
  background-color: #ff3565 !important;
}
</style>
